import { CURRENT_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  addCompany: function ({company}) {
    company.settings = {
      vat: 5,
      usd: 3.67,
      euro: 3.9
    }
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {'Authorization': 'Bearer ' + VueCookie.get('token')}
    })
    return instCred.post('companies', company)
  },
  delCompany: function (id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {'Authorization': 'Bearer ' + VueCookie.get('token')}
    })
    return instCred.delete('companies/' + id)
  },
  editCompany: function ({company}, id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {'Authorization': 'Bearer ' + VueCookie.get('token')}
    })
    return instCred.put('companies/' + id, company)
  },
  getCompanies: function () {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {'Authorization': 'Bearer ' + VueCookie.get('token')}
    })
    return instCred.get('companies')
  },
  getCompaniesById: function (id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {'Authorization': 'Bearer ' + VueCookie.get('token')}
    })
    return instCred.get('companies/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/api/Companies/api.js